import axios from "axios";
import { MAPBOX_ACCESS_TOKEN } from "config/mapConfig";

// Original OpenStreetMap geocoding function
export const reverseGeocodeWithNominatim = async (lat, lng) => {
  try {
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
    );

    if (response.data && response.data.address) {
      const { suburb, city } = response.data.address;
      return {
        suburb: suburb || "",
        city: city || "",
      };
    }

    return { suburb: "", city: "" };
  } catch (error) {
    console.error("Error during reverse geocoding:", error);
  }
};

// New Mapbox geocoding function
export const reverseGeocodeWithMapbox = async (lng, lat) => {
  try {
    const response = await axios.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_ACCESS_TOKEN}`
    );

    if (
      response.data &&
      response.data.features &&
      response.data.features.length > 0
    ) {
      // Extract suburb and city from Mapbox response
      const features = response.data.features;
      let suburb = "";
      let city = "";

      // Mapbox returns features in order of specificity (most specific first)
      // Find suburb (neighborhood) and city in the context
      for (const feature of features) {
        if (feature.place_type.includes("locality") && !suburb) {
          suburb = feature.text;
        }

        if (feature.place_type.includes("place") && !city) {
          city = feature.text;
        }
      }

      return {
        suburb: suburb || "",
        city: city || "",
      };
    }

    return { suburb: "", city: "" };
  } catch (error) {
    console.error("Error during Mapbox reverse geocoding:", error);
    return { suburb: "", city: "" };
  }
};
